export default {
  OK: "အိုကေ ",
  CLOSE: "အကောင့်ပိတ်ထားသည် ",
  BLOCK: "အကောင့်ပိတ်ထားသည် ",
  FREEZE: "အကောင့်အား ခေတ္တပိတ်ထားသည် ",
  SUSPEND: "သင်၏အကောင့်အား ကြည့်ရှုရန်သာ ခွင့်ပြုထားသည် ",
  passwordRequired: "စကားဝှက်အား ထည့်ရန် ",
  usernameRequired: "Username ထည့်ရန် ",
  incompletedRequest: "တခုခု မှားယွင်းနေသည် ...",
  unauthenticatedUser: "ခွင့်ပြုထားခြင်းမရှိပါ",

  session_not_exists: "အချိန်ကျော်လွန်သွားပါ၍ နောက်တစ်ကြိမ် ထပ်မံဝင်ရောက်ပါ ...",
  session_expired: "အချိန်ကျော်လွန်သွားပါ၍ နောက်တစ်ကြိမ် ထပ်မံဝင်ရောက်ပါ ...",
  sessionExpired: "အချိန်ကျော်လွန်သွားပါ၍ နောက်တစ်ကြိမ် ထပ်မံဝင်ရောက်ပါ ...",
  invalidSession: "အချိန်ကျော်လွန်သွားပါ၍ နောက်တစ်ကြိမ် ထပ်မံဝင်ရောက်ပါ ...",
  accountIdRequired: "အချိန်ကျော်လွန်သွားပါ၍ နောက်တစ်ကြိမ် ထပ်မံဝင်ရောက်ပါ ...",
  NoUserAccessRight: "ခွင့်ပြုထားခြင်းမရှိပါ သင်၏ အေးဂျင့်အား ဆက်သွယ်ပါ...",
  account_not_exists: "username မှားယွင်းနေသည် .",
  invalid_password: "စကားဝှက် မှားယွင်းနေသည် ",
  secondary_account_exists: "သင်၏ Nickname အား ပြုလုပ်ပြီးပါပြီ ",
  systemError: "အတွင်းစနစ် မှားယွင်းနေသည် ",
  new_login_id_exists: "အမည်မှားယွင်းနေသည် ၊ အခြားအမည်ဖြင့် အသုံးပြုပါ",
  loginLimit: "Login ဝင်ရောက်ခြင်း အကြိမ်များနေပါသည် ။ နောက်တစ်မိနစ်ကြာမှ ပြန်လည်ဝင်ရောက်ပါ ",
  requestLimit: "တောင်းဆိုမှု အကြိမ်များနေပါသည် .",

  insufficient_balance: "ငွေမလောက်ပါ",
  loginFailed: "ဝင်ရောက်၍ မရပါ ၊ ပြန်လည်ကြိုးစားပါ ...",
  requestFailed: "သင့်ချိတ်ဆက်မှု မတည်ငြိမ်ပါ။ ကျေးဇူးပြု၍ သင်၏ချိတ်ဆက်မှုကို စစ်ဆေးပြီး ထပ်စမ်းကြည့်ပါ။",
  requestPending: "တောင်းဆိုနေသည် ...",
  close: "အကောင့်ပိတ်ထားသည် ၊ သင်၏ အေးဂျင့်အားဆက်သွယ်ပါ ...",
  suspend: "အကောင့်ပိတ်ထားသည် ၊ သင်၏ အေးဂျင့်အားဆက်သွယ်ပါ ...",
  freeze: "အကောင့်ပိတ်ထားသည် ၊ သင်၏ အေးဂျင့်အားဆက်သွယ်ပါ ...",
  alphaNumOnly: "ဂဏာန်းနှင့် စာသားသာ အသုံးပြုရန် ",
  // vuelidate
  isRequired: "{fname} အားဖြည့်ပါ.",
  isMinValue: "{fname} အနည်းဆုံး {fvalue}.",
  isMaxValue: "{fname} အများဆုံး {fvalue}.",
  isMinLength: "{fname} အနည်းဆုံးစာသား {fvalue}.",
  isMaxLength: "{fname} အများဆုံးစာသား {fvalue}.",
  isAlpha: "{fname} အား အင်္ဂလိပ်စာသားသာ အသုံးပြုရန် .",
  isAlphaNum: "{fname} အား အင်္ဂလိပ်ဂဏာန်းသာ အသုံးပြုရန် .",
  isNumeric: "{fname} အား ဂဏာန်းသာ အသုံးပြုရန် .",
  isEmail: "{fname} - email လိပ်စာ အသုံးပြုရန် .",
  isIpAddress: "{fname} IPv4 လိပ်စာ အသုံးပြုရန် .",
  isSameAs: "{fname} နှင့်  {fname2} ဆင်တူရမည် .",
  isUrl: "{fname} URLs သာ အသုံးပြုရန် .",
  containAlphaNum: "{fname} အနည်းဆုံး စာသားတစ်ခုနှင့် ဂဏာန်းတစ်ခု ရှိရမည် .",
  selectOption: "{fname} အား ရွေးချယ်ပါ ",
  notSameAs: "{fname} နှင့် {fname2} မတူရပါ.",
  currPasswordRequired: "လက်ရှိစကားဝှက်!",
  newPasswordRequired: "စကားဝှက်အသစ်!",
  confirmNewPasswordRequired: "စကားဝှက်အသစ်အား အတည်ပြုပါ!",
  passwordsNotMatch: "စကားဝှက်မှားယွင်းနေပါသည်!",
  nickNameRequired: "Nick Name အားထည့်သွင်းပါ!",
  startDateRequired: "စတင်သည့်ရက်စွဲ ထည့်သွင်းပါ!",
  endDateRequired: "ပြီးဆုံးမည့် ရက်စွဲ ထည့်သွင်းပါ!",
  pageSizeRequired: "Page Size ထည့်သွင်းရန်!",
  pageNumberRequired: "Page Number ထည့်သွင်းရန်!",
  sportsTypeRequired: "Sport Type ထည့်သွင်းရန်!",
  workingDateRequired: "Working Date ထည့်သွင်းရန်!",
  leagueIdRequired: "League ID ထည့်သွင်းရန်!",
  isOutrightRequired: "Is Outright ထည့်သွင်းရန်!",

  duplicate_debit_record: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidOddsBall: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  oddsDisplayInvalid: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  oddsIsUpdating: "စျေးပြင်ဆင်နေသည် ...",
  unableToGetBalanceAtTheMoment: "အတွင်းစနစ်မှားယွင်းနေသည်.",
  atLeastTwoMatchToBetParlay: "မောင်းကစားနည်းအား အနည်းဆုံး ၂ ပွဲ ကစားရန်.",
  maxParlayTicket: "မောင်းကစားနည်း၏ အမြင့်ဆုံး ပွဲသတ်မှတ်ချက် ရောက်ရှိနေသည်!",
  matchHide: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားပွဲကို ရွေးချယ်ပါ",
  matchNotAllowBet: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားစျေးကို ရွေးချယ်ပါ.",
  invalidBets: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားစျေးကို ရွေးချယ်ပါ.",
  invalidBet: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားစျေးကို ရွေးချယ်ပါ.",
  betOverMaxPerMatch: "သတ်မှတ်လောင်း‌ကြေးထက် ကျော်လွန်နေသည်.",
  betOverMax: "သတ်မှတ်လောင်း‌ကြေးထက် ကျော်လွန်နေသည်.",
  betLowerMin: "သတ်မှတ်လောင်း‌ကြေးထက် လျော့နည်းနေသည်.",
  betOverMaxPayout: "သတ်မှတ်လျော်ကြေးထက် ကျော်လွန်နေသည်.",
  invalidBetType: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားစျေးကို ရွေးချယ်ပါ.",
  memberInactive: "အကောင့်ပိတ်ထားပါသဖြင့် အေးဂျင့်အား ဆက်သွယ်ပါ.",
  memberCommissionNotSetup: "ကော်မရှင်ထည့်သွင်းခြင်းမရှိသေးပါ.",
  matchNotActive: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားပွဲကို ရွေးချယ်ပါ.",
  invalidBetTeam: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားစျေးကို ရွေးချယ်ပါ",
  invalidOdds: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားစျေးကို ရွေးချယ်ပါ.",
  betOverMaxBet: "သတ်မှတ်လောင်းကြေးထက်ကျော်လွန်နေသည်.",
  invalidCurrency: "ငွေမလောက်ပါ.",
  betOverLimit: "သတ်မှတ်လောင်းကြေးထက်ကျော်လွန်နေသည်.",
  selectLeague: "အနည်းဆုံး လိဒ် ၁ ခု ရွေးချယ်ပါ",
  game_maintenance: "ကစားပွဲ ပြုပြင်နေသည်.",
  betTypeRequired: "ကစားနည်းအား ရွေးချယ်ပါ.",
  betAmountRequired: "လောင်း‌ကြေးအား ရွေးချယ်ပါ.",
  invalidBetAmount: "လောင်းကြေးငွေပမာဏ မှားယွင်းနေသည်.",
  currencyNotSupported: "မတူညီသော ငွေကြေးကြောင့် လက်မခံပါ",
  forbiddenAccess: "ဝင်ရောက်ခြင်းအား ပိတ်ထားသည်",

  liveCasinoDisabled: "Live Casino ပိတ်ထားသည်",
  lotteryDisabled: "Lottery ပိတ်ထားသည်",
  MiniGameDisabled: "Mini Game ပိတ်ထားသည်"
};
